import Reloader from 'components/buttons/Reloader'
import EmptyMessage from 'components/EmptyMessage'
import Screen from 'components/layout/Screen'
import { groupBy, map, reverse } from 'lodash-es'
import { CardColumns } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import API from 'state/API'
import { useUser } from 'state/Auth'
import { PRIVILEGES } from 'state/Constants'
import { fetchInvoices, useInvoices } from 'state/Invoices'
import { useDispatchEffectIf } from 'utils'
import InvoicesGroup from './InvoicesGroup'
import './styles.scss'

export default function InvoicesPage() {
	const { t }      = useTranslation()
	const dispatch   = useDispatch()
	const invoices   = useInvoices()
	const notAllowed = useUser().useFullPagePrivilege(PRIVILEGES().BILLING_INFO, 'Invoices')

	useDispatchEffectIf(!notAllowed, fetchInvoices)
	if (notAllowed) {
		return notAllowed
	}

	const corner = [
		<Reloader key="reloader" size="sm" resource={API.RESOURCES.INVOICES} reloader={() => dispatch(fetchInvoices)}/>,
	]
	return <Screen title={t('Invoices History')} corner={corner}>
		<Screen.Content>
			{/* TODO If no one complains about confusing columns in the next months or so, remove this altogether */}
			{/*<header id="list-titles">*/}
			{/*	<Row className="d-flex flex-row justify-content-between">*/}
			{/*		<Col>{t('Date')}</Col>*/}
			{/*		<Col>{t('Value')}</Col>*/}
			{/*		<Col>{t('Status')}</Col>*/}
			{/*		<Col/>*/}
			{/*	</Row>*/}
			{/*</header>*/}
			{invoices.length?
				<CardColumns>
					{invoices
						|>groupBy(#, invoice => invoice.created_at.getFullYear()) //invoices already come in DESC order from API...
						|>Object.entries|>reverse //...but object keys end up in ascending order, thus... let's revert it too
						|>map(#, ([year, invoices]) => (<InvoicesGroup {...{ invoices, year }} key={year}/>))}
				</CardColumns>
			:
				<EmptyMessage icon="file-invoice-dollar" resource={API.RESOURCES.INVOICES} msg={t('There are no Invoices available')}/>
			}
		</Screen.Content>
	</Screen>
}
